import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Roadmap from './pages/Roadmap';
import Milestones from './pages/Milestones';
import Changelog from './pages/Changelog';
import JoinTeam from './pages/JoinTeam';
import Survey from './pages/Survey';
import Otvet from './pages/Otvet';
import NotFound from './pages/NotFound';
import { darkTheme } from './theme/colors';
import './App.css';

const App: React.FC = () => {
  // Применяем тёмную тему при загрузке
  React.useEffect(() => {
    const root = document.documentElement;

    // Theme handling: keep theme on the root element for simpler selectors.
    root.setAttribute('data-theme', 'dark');

    darkTheme.gradient.forEach((color, index) => {
      root.style.setProperty(`--gradient-${index}`, color);
    });
  }, []);

  return (
    <Router>
      <div className="app">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/milestones" element={<Milestones />} />
          <Route path="/changelog" element={<Changelog />} />
          <Route path="/survey" element={<Survey />} />
          <Route path="/otvet" element={<Otvet />} />
          <Route path="/join" element={<JoinTeam />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;